import React from 'react';
import './BreadCrumb.css';
import { Link } from 'react-router-dom';

export default class MenuInterior extends React.Component{
    render(){
        return(
            <nav className="breadcrumb" aria-label="breadcrumbs">
            <ul>
                <li><Link to="/">Inicio</Link></li>
                {/* <li className='is-active'>Torneos</li> */}
            </ul>
            </nav>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/breadcrumb/BreadCrumb.js